<template>
  <Modal v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">审核合同</div>   
     <Form :model="formData" :label-width="85" :rules="formRules" ref="formValidate">
        <FormItem label="原因/备注" prop="noAuditReason">
          <Input v-model="formData.noAuditReason" type="textarea" :rows="4" ></Input>
        </FormItem>
     </Form>
     <div slot="footer">
      <div>
        <Button type="text" size="large" @click="cancel">取消</Button>
        <Button type="primary" size="large" @click="action" :loading="loading">
          <span>确定</span>
        </Button>
      </div>
    </div>
  </Modal> 
</template>
 
<script type="text/ecmascript-6">
import { confirmAudit } from 'api/auditContract'
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    contractFid:{
      type:String,
      default:''
    },
    contractCode:{
      type:String,
      default:''
    },

  },
  data () {
    return {
       show:false,
       loading:false,
       formData :{
         noAuditReason:''
       },
       formRules: {
         noAuditReason:[{ required: true, type:'string', message:'请填写驳回原因', trigger: 'blur'}],
       }
    };
  },
  watch:{
   n(val){
      this.$refs['formValidate'].resetFields();
     this.show = true;
   }
 },
  methods:{
     cancel(){
      this.show = false
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    action(){
      this.$refs['formValidate'].validate( bool => {
        if(bool) {
          let data = {
            auditType:0,
            contractCode:this.contractCode,
            contractFid:this.contractFid,
            noAuditReason:this.formData.noAuditReason
          }
          this.loading = true
          confirmAudit(data).then( res => {
            this.loading = false
            this.show = false
            this.$Message.success('驳回成功!');
            this.$emit('closeTag')
          }).catch( res => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
